var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegendaryLeague(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    preserveAspectRatio: "none",
    viewBox: "0 0 51 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M24.9233 55.9067C38.6881 55.9067 49.8467 44.6032 49.8467 30.6596C49.8467 16.7161 38.6881 5.4126 24.9233 5.4126C11.1586 5.4126 0 16.7161 0 30.6596C0 44.6032 11.1586 55.9067 24.9233 55.9067Z",
    fill: "url(#paint0_radial_4655_315611)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0126 13.8121C25.0126 13.8121 24.0832 11.6681 24.0018 8.04669C23.8933 3.28453 25.2365 0.412109 25.2365 0.412109C25.2365 0.412109 20.2843 1.16801 12.4356 8.75449C12.4356 8.75449 14.62 9.51039 14.7556 11.0153C14.8913 12.5271 13.3107 19.0278 13.3107 19.0278C13.3107 19.0278 18.4527 14.1145 25.0126 13.8053V13.8121Z",
    fill: "url(#paint1_linear_4655_315611)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1427 15.8306C15.1427 15.8306 16.9811 9.70786 13.7249 8.5259C13.7249 8.5259 18.0462 4.05923 23.2425 2.81543C23.2425 2.81543 22.7473 7.66693 23.8734 12.807C23.8734 12.807 19.8913 12.6627 15.1359 15.8306H15.1427Z",
    fill: "url(#paint2_linear_4655_315611)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4154 8.3823C14.4154 8.3823 18.3025 4.19049 22.6847 3.52393C22.6847 3.52393 22.7322 9.20691 23.5463 12.5329C23.5463 12.5329 19.0894 12.4023 15.7382 15.0823C15.7382 15.0823 17.1492 10.5538 14.4154 8.3823Z",
    fill: "#150E20"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7008 6.67639C14.2599 7.37732 17.0615 5.00655 20.4059 3.71464C23.7502 2.42962 24.6796 0.759766 24.6796 0.759766C24.6796 0.759766 20.779 1.48131 14.7076 6.66952L14.7008 6.67639Z",
    fill: "#9296A4"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7387 2.55704C22.6912 2.83192 22.7726 2.72884 23.2339 2.60515C23.6952 2.48145 24.5228 0.983398 24.5228 0.983398C24.5228 0.983398 22.8472 1.89048 22.7387 2.55704Z",
    fill: "#3D445C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.732 8.52102L14.8513 8.78215C14.8513 8.78215 16.3234 6.59691 19.1929 5.11948C22.0692 3.64204 22.7 4.19865 22.7 4.19865L23.2495 2.81055C23.2495 2.81055 18.4263 3.5527 13.732 8.52102Z",
    fill: "#742F6B"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7311 13.8121C25.7311 13.8121 26.6605 11.6681 26.7419 8.04669C26.8505 3.28453 25.5073 0.412109 25.5073 0.412109C25.5073 0.412109 30.4594 1.16801 38.3081 8.75449C38.3081 8.75449 36.1238 9.51039 35.9881 11.0153C35.8524 12.5271 37.433 19.0278 37.433 19.0278C37.433 19.0278 32.291 14.1145 25.7311 13.8053V13.8121Z",
    fill: "url(#paint3_linear_4655_315611)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.593 15.8306C35.593 15.8306 33.7546 9.70786 37.0108 8.5259C37.0108 8.5259 32.6896 4.05923 27.4932 2.81543C27.4932 2.81543 27.9885 7.66693 26.8624 12.807C26.8624 12.807 30.8444 12.6627 35.5998 15.8306H35.593Z",
    fill: "url(#paint4_linear_4655_315611)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3267 8.3823C36.3267 8.3823 32.4397 4.19049 28.0574 3.52393C28.0574 3.52393 28.0099 9.20691 27.1959 12.5329C27.1959 12.5329 31.6528 12.4023 35.0039 15.0823C35.0039 15.0823 33.5929 10.5538 36.3267 8.3823Z",
    fill: "#150E20"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0427 6.67639C36.4836 7.37732 33.682 5.00655 30.3376 3.71464C26.9932 2.42962 26.0639 0.759766 26.0639 0.759766C26.0639 0.759766 29.9645 1.48131 36.0359 6.66952L36.0427 6.67639Z",
    fill: "#9296A4"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9959 2.55704C28.0434 2.83192 27.962 2.72884 27.5007 2.60515C27.0394 2.48145 26.2118 0.983398 26.2118 0.983398C26.2118 0.983398 27.8874 1.89048 27.9959 2.55704Z",
    fill: "#3D445C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0137 8.52102L35.8944 8.78215C35.8944 8.78215 34.4223 6.59691 31.5528 5.11948C28.6765 3.64204 28.0456 4.19865 28.0456 4.19865L27.4961 2.81055C27.4961 2.81055 32.3194 3.5527 37.0137 8.52102Z",
    fill: "#742F6B"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2362 13.3164C14.4365 13.3164 5.67873 22.1879 5.67873 33.121C5.67873 44.054 14.4365 52.9324 25.2362 52.9324C36.0358 52.9324 44.7868 44.0609 44.7868 33.121C44.7868 22.181 36.0291 13.3164 25.2362 13.3164ZM25.2362 48.5688C16.8108 48.5688 9.98639 41.6558 9.98639 33.121C9.98639 24.5862 16.8108 17.68 25.2362 17.68C33.6615 17.68 40.4792 24.593 40.4792 33.121C40.4792 41.6489 33.6548 48.5688 25.2362 48.5688Z",
    fill: "url(#paint5_linear_4655_315611)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2349 15.3052C15.5206 15.3052 7.65147 23.2765 7.65147 33.1169C7.65147 42.9573 15.5206 50.9286 25.2349 50.9286C34.9491 50.9286 42.8182 42.9573 42.8182 33.1169C42.8182 23.2765 34.9491 15.3052 25.2349 15.3052ZM25.2349 48.5647C16.8095 48.5647 9.98507 41.6517 9.98507 33.1169C9.98507 24.5821 16.8095 17.676 25.2349 17.676C33.6602 17.676 40.4779 24.589 40.4779 33.1169C40.4779 41.6448 33.6534 48.5647 25.2349 48.5647Z",
    fill: "url(#paint6_linear_4655_315611)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42914 28.3051C7.42914 28.3051 10.4411 17.2895 22.0073 14.6027L20.4742 5.03711C20.4742 5.03711 16.0919 6.90624 11.7097 13.3108C11.7097 13.3108 12.4355 14.8707 11.9539 16.2313C11.4722 17.5919 9.24039 21.7219 7.19171 19.1999L8.88085 23.2612L8.06681 24.8279L5.42115 17.8668C5.42115 17.8668 4.95986 19.9627 5.2787 22.8145C5.35332 23.5085 7.42914 28.3051 7.42914 28.3051Z",
    fill: "url(#paint7_linear_4655_315611)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19114 19.2017L6.88586 20.6997L8.22226 23.2698L8.88028 23.2629L7.19114 19.2017Z",
    fill: "#0E071A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18292 21.4619C5.18292 21.4619 5.11508 22.3071 5.11508 23.7846C5.11508 24.2519 6.64819 28.3062 6.64819 28.3062H7.42833C7.42833 28.3062 5.15578 22.85 5.17613 21.4619H5.18292Z",
    fill: "#150E20"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7097 13.3081C11.7097 13.3081 11.4994 14.5451 11.4994 14.6619C11.4994 14.7787 12.4356 15.9469 10.9703 18.1459C10.9703 18.1459 12.9783 16.373 11.7097 13.3013V13.3081Z",
    fill: "#150E20"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4358 19.2004C12.4358 19.2004 13.0667 17.4481 12.9446 13.5105C12.9446 13.5105 16.0786 8.5491 19.423 6.90674C19.423 6.90674 19.8165 13.1601 19.8165 14.0878C19.8165 14.0878 15.2374 15.8057 12.4358 19.2073V19.2004Z",
    fill: "url(#paint8_linear_4655_315611)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9967 17.6715C12.9967 17.6715 13.4444 15.3557 13.397 13.5072C13.397 13.5072 16.8906 8.2365 19.1495 7.54932C19.1495 7.54932 19.2377 13.1155 19.1495 13.6171C19.0614 14.1119 16.3004 15.1495 12.9967 17.6715Z",
    fill: "url(#paint9_linear_4655_315611)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10883 23.7847C5.10883 23.7847 6.31634 31.1238 2.55138 32.1202C2.49711 39.3905 9.36221 43.8366 9.36221 43.8366C9.36221 43.8366 6.35024 39.3218 6.64872 28.3063L5.11562 23.7847H5.10883Z",
    fill: "url(#paint10_linear_4655_315611)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88339 41.7281C7.88339 41.7281 3.60967 38.6908 3.54861 32.7192C3.54861 32.7192 6.0111 30.8226 5.68548 25.9917C5.68548 25.9917 6.47238 28.3625 6.43846 29.3108C6.41133 30.2591 6.57414 36.485 7.88339 41.735V41.7281Z",
    fill: "url(#paint11_linear_4655_315611)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23254 40.852C7.23254 40.852 3.73215 38.1032 3.82033 32.7226C3.82033 32.7226 5.4145 32.4821 5.9572 28.0566L6.27603 29.1836C6.27603 29.1836 6.37101 36.4815 7.23254 40.8451V40.852Z",
    fill: "url(#paint12_linear_4655_315611)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55049 32.1171C2.55049 32.1171 4.93156 30.5916 5.27075 27.1763C5.27075 27.1763 5.52854 31.4505 2.55049 32.1171Z",
    fill: "#3D445C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19118 19.1996C7.19118 19.1996 8.22908 20.1136 9.28734 19.6669C10.3388 19.2271 11.4717 17.5366 11.4717 17.5366C11.4717 17.5366 9.99284 19.928 8.88032 20.1342C7.76779 20.3403 7.19118 19.1996 7.19118 19.1996Z",
    fill: "#3D445C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9967 13.3118L13.397 14.0608C13.397 14.0608 15.3235 10.7486 17.1348 9.31236C18.9393 7.87615 19.1902 8.12354 19.1902 8.12354L19.4209 6.90723C19.4209 6.90723 17.3112 7.93113 15.5813 10.0683C13.8515 12.2054 12.9967 13.3118 12.9967 13.3118Z",
    fill: "#742F6B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54861 32.7948L3.91492 33.5713C3.91492 33.5713 4.14558 32.781 4.56617 32.4581C4.98676 32.1351 5.81437 31.6609 6.04501 30.5202C6.27566 29.3795 6.07893 27.3248 6.07893 27.3248L5.68548 25.9917C5.68548 25.9917 5.95683 28.4381 5.11565 30.4378C4.27447 32.4375 3.54861 32.7879 3.54861 32.7879V32.7948Z",
    fill: "#742F6B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3044 16.9391C13.3044 16.9391 13.9081 14.2797 15.7736 12.7611C17.6392 11.2424 18.4736 13.0909 18.5143 13.6132C18.5618 14.1354 13.3044 16.9391 13.3044 16.9391Z",
    fill: "#15FFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95579 39.2456C5.95579 39.2456 4.8704 38.1668 4.85005 36.6343C4.82969 35.1019 5.67766 34.1193 5.95579 33.7825C6.23393 33.4527 7.00049 40.297 7.00049 40.297L5.95579 39.2456Z",
    fill: "#15FFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3249 9.24398C17.8026 8.81793 18.0536 10.3022 18.3249 10.4809C18.5963 10.6596 18.5488 9.42265 18.3249 9.24398Z",
    fill: "#86FFFF"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7457 8.76512C15.4947 9.22553 18.9815 7.16398 19.4224 6.90973C19.8566 6.65547 20.3993 5.30859 20.3993 5.30859C20.3993 5.30859 17.1431 6.66234 15.7457 8.76512Z",
    fill: "#3D445C"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9985 17.6773L12.4354 19.2028C12.4354 19.2028 13.7447 17.9728 14.6334 17.0795C15.522 16.1792 15.7391 16.0762 15.7391 16.0762C15.7391 16.0762 13.8939 16.7771 12.9985 17.6773Z",
    fill: "#7C4C82"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3147 28.3051C43.3147 28.3051 40.3027 17.2895 28.7365 14.6027L30.2696 5.03711C30.2696 5.03711 34.6519 6.90624 39.0342 13.3108C39.0342 13.3108 38.3083 14.8707 38.79 16.2313C39.2716 17.5919 41.5035 21.7219 43.5522 19.1999L41.863 23.2612L42.677 24.8279L45.3227 17.8668C45.3227 17.8668 45.784 19.9627 45.4651 22.8145C45.3905 23.5085 43.3147 28.3051 43.3147 28.3051Z",
    fill: "url(#paint13_linear_4655_315611)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5609 19.2017L43.8662 20.6997L42.5366 23.8745L41.8718 23.2629L43.5609 19.2017Z",
    fill: "#0E071A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5662 21.4619C45.5662 21.4619 45.6341 22.3071 45.6341 23.7846C45.6341 24.2519 44.101 28.3062 44.101 28.3062H43.3208C43.3208 28.3062 45.5934 22.85 45.573 21.4619H45.5662Z",
    fill: "#150E20"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0418 13.3081C39.0418 13.3081 39.2521 14.5451 39.2521 14.6619C39.2521 14.7787 38.3159 15.9469 39.7812 18.1459C39.7812 18.1459 37.7732 16.373 39.0418 13.3013V13.3081Z",
    fill: "#150E20"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3151 19.2009C38.3151 19.2009 37.6843 17.4486 37.7996 13.511C37.7996 13.511 34.6655 8.54959 31.3211 6.90723C31.3211 6.90723 30.9277 13.1606 30.9277 14.0883C30.9277 14.0883 35.5067 15.8062 38.3084 19.2078L38.3151 19.2009Z",
    fill: "url(#paint14_linear_4655_315611)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7519 17.6715C37.7519 17.6715 37.3042 15.3557 37.3517 13.5072C37.3517 13.5072 33.8581 8.2365 31.5991 7.54932C31.5991 7.54932 31.5109 13.1155 31.5991 13.6171C31.6873 14.1188 34.4482 15.1495 37.7519 17.6715Z",
    fill: "url(#paint15_linear_4655_315611)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6343 23.7842C45.6343 23.7842 44.4268 31.1233 48.1918 32.1197C48.2461 39.3901 41.381 43.8361 41.381 43.8361C41.381 43.8361 44.3929 39.3213 44.0944 28.3058L45.6276 23.7842H45.6343Z",
    fill: "url(#paint16_linear_4655_315611)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8676 41.7281C42.8676 41.7281 47.1413 38.6908 47.2023 32.7192C47.2023 32.7192 44.7399 30.8226 45.0655 25.9917C45.0655 25.9917 44.2786 28.3625 44.3125 29.3108C44.3396 30.2591 44.1768 36.485 42.8676 41.735V41.7281Z",
    fill: "url(#paint17_linear_4655_315611)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5181 40.852C43.5181 40.852 47.0185 38.1032 46.9303 32.7226C46.9303 32.7226 45.3361 32.4821 44.7934 28.0566L44.4746 29.1836C44.4746 29.1836 44.3796 36.4815 43.5181 40.8451V40.852Z",
    fill: "url(#paint18_linear_4655_315611)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2003 32.1171C48.2003 32.1171 45.8192 30.5916 45.48 27.1763C45.48 27.1763 45.2222 31.4505 48.2003 32.1171Z",
    fill: "#3D445C"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5619 19.1996C43.5619 19.1996 42.524 20.1136 41.4657 19.6669C40.4143 19.2271 39.2814 17.5366 39.2814 17.5366C39.2814 17.5366 40.7602 19.928 41.8728 20.1342C42.9785 20.3403 43.5619 19.1996 43.5619 19.1996Z",
    fill: "#3D445C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7511 13.3118L37.3509 14.0608C37.3509 14.0608 35.4243 10.7486 33.613 9.31236C31.8018 7.87615 31.5576 8.12354 31.5576 8.12354L31.3269 6.90723C31.3269 6.90723 33.4367 7.93113 35.1665 10.0683C36.8964 12.2054 37.7511 13.3118 37.7511 13.3118Z",
    fill: "#742F6B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2022 32.7948L46.8359 33.5713C46.8359 33.5713 46.6053 32.781 46.1847 32.4581C45.7641 32.1351 44.9365 31.6609 44.7058 30.5202C44.4752 29.3795 44.6719 27.3248 44.6719 27.3248L45.0654 25.9917C45.0654 25.9917 44.794 28.4381 45.6352 30.4378C46.4764 32.4375 47.2022 32.7879 47.2022 32.7879V32.7948Z",
    fill: "#742F6B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M37.439 16.9391C37.439 16.9391 36.8352 14.2797 34.9697 12.7611C33.1042 11.2424 32.2698 13.0909 32.2291 13.6132C32.1816 14.1354 37.439 16.9391 37.439 16.9391Z",
    fill: "#15FFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7929 39.2456C44.7929 39.2456 45.8783 38.1668 45.8987 36.6343C45.919 35.1019 45.0711 34.1193 44.7929 33.7825C44.5148 33.4527 43.7482 40.297 43.7482 40.297L44.7929 39.2456Z",
    fill: "#15FFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4266 9.24398C32.949 8.81793 32.698 10.3022 32.4266 10.4809C32.1553 10.6596 32.2028 9.42265 32.4266 9.24398Z",
    fill: "#86FFFF"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0041 8.76463C35.2551 9.22504 31.7683 7.16349 31.3273 6.90924C30.8932 6.65498 30.3505 5.30811 30.3505 5.30811C30.3505 5.30811 33.6067 6.66185 35.0041 8.76463Z",
    fill: "#3D445C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7524 17.6773L38.3154 19.2028C38.3154 19.2028 37.0062 17.9728 36.1175 17.0795C35.2288 16.1861 35.0118 16.0762 35.0118 16.0762C35.0118 16.0762 36.8569 16.7771 37.7524 17.6773Z",
    fill: "#7C4C82"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88399 30.2033C7.88399 30.2033 13.4738 17.6691 25.2367 17.6691C36.9997 17.6691 42.7658 31.77 42.7658 31.77C42.7658 31.77 39.1569 15.3052 25.2367 15.3052C11.3166 15.3052 7.88399 30.2033 7.88399 30.2033Z",
    fill: "#742F6B"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7886 15.3023C24.7886 15.3023 27.1833 14.4159 30.202 15C33.2208 15.5772 35.7647 18.8482 35.7647 18.8482C35.7647 18.8482 32.0811 15.426 24.7886 15.3023Z",
    fill: "#3D445C"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8437 47.4882C13.7583 46.6154 20.3521 48.7594 25.5077 48.6976C30.6633 48.6357 38.7495 44.5195 38.7495 44.5195C38.7495 44.5195 34.0687 50.285 26.0979 50.9309C18.1338 51.5769 14.8437 47.4882 14.8437 47.4882Z",
    fill: "#434A61"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M41.74 38.7288C41.177 38.7082 40.7225 39.9245 41.3127 40.6804C41.8961 41.4294 43.0154 38.7837 41.74 38.7288Z",
    fill: "#150E20"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1155 39.6707C41.224 40.3098 42.0177 40.138 42.228 39.7394C42.4451 39.334 42.2484 38.5987 41.665 38.7361C41.0816 38.8735 41.1087 39.6707 41.1087 39.6707H41.1155Z",
    fill: "#BE2F55"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0895 40.2484C41.1642 39.8292 41.734 40.1728 42.0189 40.1178C42.3038 40.0628 41.9782 40.805 41.6322 40.7981C41.2863 40.7981 41.0827 40.2484 41.0827 40.2484H41.0895Z",
    fill: "#434A61"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M14.117 46.9175C14.117 46.9175 15.8739 49.2539 20.8464 50.6351C20.8464 50.6351 18.0922 48.12 14.117 46.9175Z",
    fill: "#4D546A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3258 51.5845C25.3258 51.5845 21.4727 51.5708 14.7229 49.2344L16.0932 55.5152C16.0932 55.5152 20.8621 58.8549 25.3258 58.8549C29.7895 58.8549 34.5584 55.5152 34.5584 55.5152L35.9288 49.2344C29.179 51.5777 25.3258 51.5845 25.3258 51.5845Z",
    fill: "url(#paint19_linear_4655_315611)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6766 50.9233C16.6766 50.9233 23.4331 53.1773 34.1446 50.9921L33.6901 54.3936C33.6901 54.3936 30.3458 57.8295 25.2376 57.8295C20.1295 57.8295 17.1921 54.854 17.1921 54.854L16.6698 50.9233H16.6766Z",
    fill: "url(#paint20_linear_4655_315611)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3062 51.8361C17.3062 51.8361 26.3218 53.3479 33.6414 51.623L33.248 54.3786C33.248 54.3786 30.331 57.0243 25.406 57.2992C20.7388 57.5603 17.7065 54.7085 17.7065 54.7085L17.3062 51.8429V51.8361Z",
    fill: "#150E20"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8666 57.8125C25.8666 57.8125 26.4229 57.5239 28.4308 56.8023C30.4456 56.0808 31.9448 55.7578 31.9448 55.7578C31.9448 55.7578 28.7293 57.9843 25.8666 57.8056V57.8125Z",
    fill: "#555B70"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6766 50.9233L17.4906 52.0847C17.4906 52.0847 21.1267 53.2048 25.4072 53.2048C29.6877 53.2048 33.6223 51.7411 33.6223 51.7411L34.1379 50.9921C34.1379 50.9921 24.3761 53.1292 16.6698 50.9233H16.6766Z",
    fill: "#742F6B"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1994 43.8422C11.1994 43.8422 7.93639 41.066 7.65147 33.5757C7.65147 33.5757 7.78037 37.9393 11.1994 43.8422Z",
    fill: "#434A61"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3311 17.8696L45.6432 23.7863C45.6432 23.7863 46.2944 19.4845 45.3311 17.8696Z",
    fill: "#3D445C"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42006 17.8696L5.10802 23.7863C5.10802 23.7863 4.15829 19.0585 5.42006 17.8696Z",
    fill: "#3D445C"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55049 32.1194C2.55049 32.1194 3.19494 32.0919 3.41202 31.9683C3.62231 31.8446 4.01578 31.3154 4.01578 31.3154L2.55049 32.1194Z",
    fill: "#50566C"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8342 31.4062C46.8342 31.4062 47.5533 31.578 47.6279 31.6468C47.7025 31.7155 48.1977 32.114 48.1977 32.114C48.1977 32.114 47.1734 31.7773 46.8342 31.4062Z",
    fill: "#50566C"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2501 49.4533C32.2501 49.4533 34.3191 47.6528 35.2349 47.2886C36.1575 46.9244 36.5374 46.6221 36.5374 46.6221C36.5374 46.6221 35.4045 48.7798 32.2433 49.4533H32.2501Z",
    fill: "#50566C"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0897 17.9005C16.0897 17.9005 19.3663 15.6121 24.7797 15.3029C24.7797 15.3029 21.0147 14.3271 16.0897 17.9005Z",
    fill: "#3E455D"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86455 28.9565C7.30151 28.9771 6.9352 30.2278 7.57965 30.9356C8.21732 31.6365 9.13989 28.9153 7.86455 28.9565Z",
    fill: "#150E20"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31543 29.9378C7.47146 30.5632 8.24479 30.3364 8.43474 29.9172C8.6179 29.498 8.36691 28.7765 7.80386 28.962C7.23403 29.1407 7.32222 29.9378 7.32222 29.9378H7.31543Z",
    fill: "#BE2F55"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33678 30.5244C7.37748 30.0983 7.97446 30.3938 8.25937 30.3251C8.5375 30.2495 8.27293 31.0123 7.92696 31.0329C7.58099 31.0535 7.34357 30.5244 7.34357 30.5244H7.33678Z",
    fill: "#434A61"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3741 22.0989L13.222 22.525C13.222 22.525 17.8282 17.11 24.7883 17.11C31.7484 17.11 36.3545 21.9959 36.3545 21.9959L37.4331 21.2881C37.4331 21.2881 32.9491 15.8662 24.7883 15.8662C16.6275 15.8662 12.3673 22.0921 12.3673 22.0921L12.3741 22.0989Z",
    fill: "url(#paint21_linear_4655_315611)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6932 21.6808L13.2223 22.0999C13.2223 22.0999 18.0252 16.8774 24.9039 16.8774C31.7826 16.8774 36.2531 21.4815 36.2531 21.4815L37.1485 20.9798C37.1485 20.9798 32.8341 15.9565 24.9175 15.9565C17.0009 15.9565 12.6864 21.6808 12.6864 21.6808H12.6932Z",
    fill: "url(#paint22_linear_4655_315611)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3264 45.9255C10.3264 45.9255 10.9234 44.3313 11.2016 44.0083C11.4797 43.6853 13.664 43.1699 13.664 43.1699C13.664 43.1699 12.6533 43.2318 12.3412 43.3692C12.0224 43.5066 10.8081 42.8676 10.6046 42.8882C10.4011 42.9088 10.3332 45.9255 10.3332 45.9255H10.3264Z",
    fill: "#150E20"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8804 44.5723C10.8804 44.5723 11.3146 44.2974 11.396 44.2493C11.4774 44.2081 12.2982 43.5347 12.2982 43.5347C12.2982 43.5347 11.396 43.6584 11.1653 43.7546C10.9415 43.8439 10.8736 44.5723 10.8736 44.5723H10.8804Z",
    fill: "#353C55"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3805 45.5503C10.3805 45.5503 11.0385 43.8942 11.1742 43.7568C11.3099 43.6194 11.4591 43.3307 11.4591 43.3307C11.4591 43.3307 10.7129 42.8497 10.5976 42.8841C10.4823 42.9184 10.3398 44.9456 10.3805 45.5503Z",
    fill: "#742F6B"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1062 43.768C11.1062 43.768 11.3979 44.036 11.5132 44.0566C11.6285 44.0772 11.9473 43.5962 11.9473 43.5962C11.9473 43.5962 11.4046 43.6512 11.1062 43.768Z",
    fill: "#4D546A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M12.224 43.3863C12.224 43.3863 12.3055 43.4894 12.509 43.4756C12.7057 43.4619 13.4519 43.2214 13.4519 43.2214C13.4519 43.2214 12.8549 43.2008 12.2308 43.3863H12.224Z",
    fill: "#742F6B"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7048 42.9052C10.7048 42.9052 10.0264 41.9569 9.92465 41.9363C9.82968 41.9157 10.5013 43.0221 10.5013 43.0221L10.698 42.9052H10.7048Z",
    fill: "#656B7E"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9 15.5653C11.9 15.5653 10.9299 14.8781 9.58672 15.8676C8.24354 16.8572 8.53523 19.7296 8.53523 19.7296C8.53523 19.7296 9.32216 20.6092 10.801 18.5958C12.2799 16.5823 11.9067 15.5653 11.9067 15.5653H11.9Z",
    fill: "url(#paint23_linear_4655_315611)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7935 19.6995C8.23045 19.3353 8.88169 17.6174 10.7676 16.7996C12.6534 15.975 10.8286 18.8337 9.93318 19.404C9.03773 19.9744 8.7935 19.6995 8.7935 19.6995Z",
    fill: "#15FFFF"
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7947 16.0326C10.6116 16.4105 11.0321 16.3762 11.1543 16.1288C11.2764 15.8814 10.8558 15.902 10.7947 16.0326Z",
    fill: "#FFCFDD"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50165 19.1471C8.50165 19.1471 8.53556 17.1405 9.68201 16.1785C10.8285 15.2164 11.6629 15.4432 11.6629 15.4432C11.6629 15.4432 10.6656 14.9553 9.45136 15.993C8.37275 16.9138 8.50844 19.1471 8.50844 19.1471H8.50165Z",
    fill: "#742F6B"
  }))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M38.945 15.5653C38.945 15.5653 39.915 14.8781 41.2582 15.8676C42.6014 16.8572 42.3097 19.7296 42.3097 19.7296C42.3097 19.7296 41.5228 20.6092 40.0439 18.5958C38.5651 16.5823 38.9382 15.5653 38.9382 15.5653H38.945Z",
    fill: "url(#paint24_linear_4655_315611)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0452 19.6995C42.6082 19.3353 41.957 17.6174 40.0711 16.7996C38.1852 15.975 40.01 18.8337 40.9055 19.404C41.8009 19.9813 42.0452 19.6995 42.0452 19.6995Z",
    fill: "#15FFFF"
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0435 16.0326C40.2266 16.4105 39.8061 16.3762 39.6839 16.1288C39.5618 15.8814 39.9824 15.902 40.0435 16.0326Z",
    fill: "#FFCFDD"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3369 19.1471C42.3369 19.1471 42.303 17.1405 41.1565 16.1785C40.0101 15.2164 39.1757 15.4432 39.1757 15.4432C39.1757 15.4432 40.1729 14.9553 41.3872 15.993C42.4658 16.9138 42.3301 19.1471 42.3301 19.1471H42.3369Z",
    fill: "#742F6B"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M43.1249 35.588C44.4613 33.5058 46.5236 32.4682 47.7446 33.2722C48.9657 34.0762 48.8707 36.4126 47.5343 38.4879C46.1979 40.5701 44.1357 41.6077 42.9146 40.8037C41.6936 39.9997 41.7885 37.6633 43.1249 35.588Z",
    fill: "url(#paint25_radial_4655_315611)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M30.5534 10.5334C31.8898 8.45121 34.7864 7.96331 37.0318 9.44075C39.2772 10.9182 40.0166 13.8043 38.687 15.8865C37.3574 17.9687 34.454 18.4566 32.2086 16.9791C29.9632 15.5017 29.2238 12.6155 30.5534 10.5402V10.5334Z",
    fill: "url(#paint26_radial_4655_315611)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M11.7039 17.0659C10.1707 15.1281 10.8152 12.0289 13.142 10.1391C15.4688 8.2494 18.5961 8.29063 20.1225 10.2285C21.6556 12.1663 21.0111 15.2655 18.6843 17.1553C16.3575 19.045 13.2302 19.0038 11.7039 17.0659Z",
    fill: "url(#paint27_radial_4655_315611)"
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1418 26.48L21.154 39.0341H18.8832L14.8769 26.48H17.3139L19.2155 32.794L20.0832 36.0433L21.0063 32.7755L22.8894 26.48H25.1418Z",
    fill: "#3D91FF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3508 39.0341H27.1354V26.48H29.3508V39.0341Z",
    fill: "#3D91FF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M35.03 39.0341H32.8146V26.48H35.03V39.0341Z",
    fill: "#3D91FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4655_315611",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.9234 30.6596) scale(24.9234 25.247)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "transparent",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#0000F9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0000B8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#000080",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#000052",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "transparent",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4655_315611",
    x1: 18.8326,
    y1: 19.0347,
    x2: 18.8326,
    y2: 0.418982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242438"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4655_315611",
    x1: 18.8059,
    y1: 15.8306,
    x2: 18.8059,
    y2: 2.80856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#404051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E0719"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4655_315611",
    x1: 31.9043,
    y1: 19.0347,
    x2: 31.9043,
    y2: 0.418982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242438"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4655_315611",
    x1: 31.9366,
    y1: 15.8306,
    x2: 31.9366,
    y2: 2.80856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#404051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E0719"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4655_315611",
    x1: 25.2362,
    y1: 52.9324,
    x2: 25.2362,
    y2: 13.3164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242438"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4655_315611",
    x1: 25.2348,
    y1: 50.9286,
    x2: 25.2348,
    y2: 15.3052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#404051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E0719"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4655_315611",
    x1: 13.5887,
    y1: 28.3051,
    x2: 13.5887,
    y2: 5.03711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242438"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4655_315611",
    x1: 16.1261,
    y1: 19.2004,
    x2: 16.1261,
    y2: 6.90674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8268AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#2F2D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E0719"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4655_315611",
    x1: 16.0901,
    y1: 17.6715,
    x2: 16.0901,
    y2: 7.54932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#276AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E24D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4655_315611",
    x1: 5.95679,
    y1: 43.8435,
    x2: 5.95679,
    y2: 23.7847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242438"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4655_315611",
    x1: 5.71261,
    y1: 41.7281,
    x2: 5.71261,
    y2: 25.9917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8268AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#2F2D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E0719"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4655_315611",
    x1: 5.52304,
    y1: 40.852,
    x2: 5.52304,
    y2: 28.0635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#276AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E24D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4655_315611",
    x1: 37.1619,
    y1: 28.3051,
    x2: 37.1619,
    y2: 5.03711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242438"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4655_315611",
    x1: 34.6248,
    y1: 19.2009,
    x2: 34.6248,
    y2: 6.90723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8268AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#2F2D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E0719"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4655_315611",
    x1: 34.6585,
    y1: 17.6715,
    x2: 34.6585,
    y2: 7.54932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#276AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E24D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4655_315611",
    x1: 44.7932,
    y1: 43.843,
    x2: 44.7932,
    y2: 23.7842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242438"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4655_315611",
    x1: 45.0383,
    y1: 41.7281,
    x2: 45.0383,
    y2: 25.9917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8268AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#2F2D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E0719"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4655_315611",
    x1: 45.2276,
    y1: 40.852,
    x2: 45.2276,
    y2: 28.0635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#276AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E24D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4655_315611",
    x1: 25.3258,
    y1: 58.8549,
    x2: 25.3258,
    y2: 49.2344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242438"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4655_315611",
    x1: 25.4072,
    y1: 57.8295,
    x2: 25.4072,
    y2: 50.9233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#404051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E0719"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4655_315611",
    x1: 24.9104,
    y1: 22.525,
    x2: 24.9104,
    y2: 15.8731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8268AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#2F2D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E0719"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4655_315611",
    x1: 24.9243,
    y1: 22.0999,
    x2: 24.9243,
    y2: 15.9565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#276AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E24D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4655_315611",
    x1: 10.1537,
    y1: 19.9502,
    x2: 10.2826,
    y2: 15.3067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#276AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E24D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4655_315611",
    x1: 40.6769,
    y1: 19.951,
    x2: 40.548,
    y2: 15.3075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#276AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E24D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_4655_315611",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.1101 35.8542) rotate(-146.682) scale(2.64661 4.46563)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#0036F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0028B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#001C80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#001252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#000A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#000414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#000105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_4655_315611",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4276 12.0555) rotate(-146.682) scale(4.86787 4.46563)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#0036F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0028B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#001C80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#001252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#000A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#000414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#000105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_4655_315611",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.5815 12.1981) rotate(140.939) scale(5.41802 4.46016)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#0036F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0028B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#001C80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#001252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#000A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#000414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#000105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegendaryLeague);
export default __webpack_public_path__ + "static/media/legendary-league.cca4bf03850034aa3f0d669b65cc3882.svg";
export { ForwardRef as ReactComponent };